// Modules
import { createApi } from '@reduxjs/toolkit/query/react';
import { endpoints } from 'config/api';
import { axiosBaseQuery } from 'config/axiosBaseQuery';

// Utils
import { Document } from 'features/commons/commonsTypes';

// Types
export interface UploadWorkOrderDocumentParams {
  workOrderId: string;
  formData: FormData;
}

export interface DeleteWorkOrderDocumentParams {
  workOrderId: string;
  documentId: string;
}

export interface GetWorkOrderDocumentUrlParams {
  workOrderId: string;
  documentId: string;
}

export interface WorkOrderDocumentUrlResponse {
  url: string;
}

export const workOrdersDocumentsApi = createApi({
  reducerPath: 'workOrdersDocumentsApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['WorkOrderDocuments', 'WorkOrder'],
  endpoints: (builder) => ({
    uploadWorkOrderDocument: builder.mutation<Document, UploadWorkOrderDocumentParams>({
      query: ({ workOrderId, formData }) => ({
        url: endpoints.workOrders.documents(workOrderId),
        method: 'POST',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }),
      invalidatesTags: (_res, _err, { workOrderId }) => [
        { type: 'WorkOrderDocuments', id: workOrderId },
        { type: 'WorkOrder', id: workOrderId }
      ],
    }),

    deleteWorkOrderDocument: builder.mutation<void, DeleteWorkOrderDocumentParams>({
      query: ({ workOrderId, documentId }) => ({
        url: `${endpoints.workOrders.documents(workOrderId)}/${documentId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_res, _err, { workOrderId }) => [
        { type: 'WorkOrderDocuments', id: workOrderId },
        { type: 'WorkOrder', id: workOrderId }
      ],
    }),

    getWorkOrderDocumentUrl: builder.query<WorkOrderDocumentUrlResponse, GetWorkOrderDocumentUrlParams>({
      query: ({ workOrderId, documentId }) => ({
        url: `${endpoints.workOrders.documents(workOrderId)}/${documentId}/url`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useUploadWorkOrderDocumentMutation,
  useDeleteWorkOrderDocumentMutation,
  useGetWorkOrderDocumentUrlQuery,
  useLazyGetWorkOrderDocumentUrlQuery,
} = workOrdersDocumentsApi;
